import { SVGProps } from 'react';

export const SlotsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    {...props}>
    <path
      d="M6.93181 3.05253C8.08299 3.6255 8.77445 4.63417 8.99123 6.05168C9.18185 7.30207 8.909 8.66586 8.19886 9.99384C7.78772 10.7608 7.46629 11.6232 7.23082 12.3544C7.49245 12.3574 7.74661 12.3663 7.99703 12.3842C8.22128 11.6978 8.52029 10.919 8.88658 10.2266C9.64905 8.80314 9.94058 7.33191 9.73128 5.97707C9.664 5.53541 9.55187 5.12657 9.39863 4.75354C10.9722 6.11136 12.9643 8.37938 14.3136 11.847C14.3846 11.8381 14.4519 11.8262 14.5229 11.8172C14.706 11.7963 14.8854 11.7814 15.0648 11.7665C12.4709 4.9684 7.5373 2.6407 7.31678 2.53924C7.14112 2.45867 6.91312 2.50641 6.80847 2.64369C6.70382 2.78395 6.75988 2.96598 6.93181 3.05253Z"
      fill="#CACFFB"
    />
    <path
      d="M20.6395 16.0352C20.228 13.2852 17.7498 12.1566 14.9646 12.5894C13.923 12.7526 12.9924 13.1155 12.2512 13.6415C13.4528 14.5104 14.1548 15.8421 14.1548 17.4701C14.1548 18.8384 13.665 20.0969 12.852 21.079C13.8511 21.7049 15.0756 21.9946 16.3457 21.7982C19.1277 21.3654 21.0541 18.7852 20.6395 16.0352Z"
      fill="#CACFFB"
    />
    <path
      d="M8.40455 13.1814C5.58669 13.1814 3.30432 14.6796 3.30432 17.4595C3.30432 20.2394 5.58669 22.5 8.40455 22.5C11.2224 22.5 13.5048 20.2461 13.5048 17.4628C13.5048 14.6796 11.2191 13.1814 8.40455 13.1814ZM6.3083 15.2788C5.39731 15.725 4.93692 16.4607 4.93692 17.4628C4.93692 17.6459 4.78998 17.7958 4.6104 17.7958C4.43081 17.7958 4.28388 17.6459 4.28388 17.4628C4.28388 16.1977 4.88467 15.2356 6.02749 14.6762C6.19075 14.5963 6.38666 14.6663 6.46176 14.8327C6.54013 14.9992 6.47156 15.1989 6.3083 15.2788Z"
      fill="#CACFFB"
    />
  </svg>
);
